/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PutApiCostcentersIdMutationRequest,
  PutApiCostcentersIdMutationResponse,
  PutApiCostcentersIdPathParams,
} from '../models/PutApiCostcentersId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  putApiCostcentersIdMutationResponseSchema,
  putApiCostcentersIdMutationRequestSchema,
} from '../zod/putApiCostcentersIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const putApiCostcentersIdMutationKey = () =>
  [{ url: '/api/costCenters/:id' }] as const;

export type PutApiCostcentersIdMutationKey = ReturnType<
  typeof putApiCostcentersIdMutationKey
>;

/**
 * {@link /api/costCenters/:id}
 */
export async function putApiCostcentersId(
  id: PutApiCostcentersIdPathParams['id'],
  data: PutApiCostcentersIdMutationRequest,
  config: Partial<RequestConfig<PutApiCostcentersIdMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = putApiCostcentersIdMutationRequestSchema.parse(data);
  const res = await request<
    PutApiCostcentersIdMutationResponse,
    ResponseErrorConfig<Error>,
    PutApiCostcentersIdMutationRequest
  >({
    method: 'PUT',
    url: `/api/costCenters/${id}`,
    data: requestData,
    ...requestConfig,
  });
  return putApiCostcentersIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/costCenters/:id}
 */
export function usePutApiCostcentersId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiCostcentersIdMutationResponse,
      ResponseErrorConfig<Error>,
      {
        id: PutApiCostcentersIdPathParams['id'];
        data: PutApiCostcentersIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiCostcentersIdMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiCostcentersIdMutationKey();

  return useMutation<
    PutApiCostcentersIdMutationResponse,
    ResponseErrorConfig<Error>,
    {
      id: PutApiCostcentersIdPathParams['id'];
      data: PutApiCostcentersIdMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return putApiCostcentersId(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
